<div class="message-dialog">
  <div mat-dialog-content fxLayout="column" fxLayoutGap="50px">
    <div class="message">
      {{ data.message }}
    </div>

    <div class="message-button" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="15px">
      <button mat-stroked-button color="primary" *ngIf="!hiddenCancel" (click)="onNoClick()">{{'キャンセル' | translate
        }}</button>
      <button mat-flat-button color="primary" (click)="onOkClick()">{{'OK' | translate }}</button>
    </div>
  </div>
</div>